import { Box, Chip } from "@mui/material";
import { visuallyHidden } from "@mui/utils";

import { AppointmentAttendanceStatus } from "@/pages/clients/client/components/tabs/notes-tab/CaseNotes.types";
import { useTranslation } from "@/translations";

import { AppointmentStatusColor, AppointmentStatusSymbol } from "./AppointmentStatusChip.utils";

interface Props {
  status: AppointmentAttendanceStatus;
  showStatusText?: boolean;
}

export function AppointmentStatusChip({ status, showStatusText = false }: Props) {
  const { t } = useTranslation();
  const statusText = t(`clients.client.caseNotes.appointmentStatus.${status}`);

  return (
    <Chip
      size="small"
      variant="outlined"
      color={AppointmentStatusColor[status]}
      sx={{ fontWeight: "bold" }}
      label={
        <>
          <span aria-hidden>
            {showStatusText ? `${AppointmentStatusSymbol[status]} ${statusText}` : AppointmentStatusSymbol[status]}
          </span>
          <Box component="span" sx={visuallyHidden}>
            {t("clients.client.caseNotes.appointmentStatusLabel", { status: statusText })}
          </Box>
        </>
      }
    />
  );
}
